<script lang="ts">
	import { getContext } from 'svelte';
	import DefaultDateInput from '../../input/DefaultDateInput.svelte';
	import {
		FilterCondition,
		buildFilterValue,
		type FilterOption,
		type SimpleListContext
	} from '../../../types/ListTypes';

	const { updateFilterActivityState } = getContext<SimpleListContext>('enzianListContext');

	//Is ignored anyway
	let filterCondition: FilterCondition = FilterCondition.EQ;

	interface Props {
		propertyName: string;
		filterOption: FilterOption;
	}

	let { propertyName, filterOption = $bindable() }: Props = $props();

	async function handleFromChange(e: any) {
		//Grab the valuie from the event
		const dateValueFrom = e.value;
		const dateValueTill = parseUntilDate(filterOption.value);
		//Apply the update to the filter object
		updateValueOnFilterObject(dateValueFrom, dateValueTill);
	}

	async function handleTillChange(e: any) {
		//Grab the valuie from the event
		const dateValueFrom = parseFromDate(filterOption.value);
		const dateValueTill = e.value;
		//Apply the update to the filter object
		updateValueOnFilterObject(dateValueFrom, dateValueTill);
	}

	function updateValueOnFilterObject(dateValueFrom: string | null, dateValueTill: string | null) {
		if (dateValueFrom == null && dateValueTill == null) {
			//Check if we should force the null value or not
			if (filterOption.dateOptions?.forceNull == true) {
				filterOption.value = buildFilterValue(null, filterCondition);
			} else {
				filterOption.value = null;
			}

			updateFilterActivityState();
		} else {
			filterOption.value = buildFilterValue(dateValueFrom + ';' + dateValueTill, filterCondition);
			updateFilterActivityState();
		}
	}

	function parseFromDate(rawValue: string | null): string | null {
		//Read value back in.
		if (rawValue != null && rawValue != 'null') {
			const values = rawValue.split('|');
			const parsedValue = values.length >= 2 ? values[0] : null;

			const rawValues = parsedValue!.split(';');

			const dateFrom = rawValues[0];

			if (dateFrom == 'null' || dateFrom == 'undefined') {
				return null;
			} else {
				return rawValues[0];
			}
		} else {
			return null;
		}
	}

	function parseUntilDate(rawValue: string | null): string | null {
		//Read value back in.
		if (rawValue != null) {
			const values = rawValue.split('|');
			const parsedValue = values.length >= 2 ? values[0] : null;

			if (parsedValue == 'null' || parsedValue == 'undefined') {
				return null;
			} else {
				const rawValues = parsedValue!.split(';');

				const dateUntil = rawValues[1];

				if (dateUntil == 'null' || dateUntil == 'undefined') {
					return null;
				} else {
					return rawValues[1];
				}
			}
		} else {
			return null;
		}
	}
</script>

<div class="flex items-center gap-2">
	<DefaultDateInput
		id={propertyName}
		propertyName="value"
		value={parseFromDate(filterOption.value)}
		callFunction={handleFromChange}
	/>
	<p>{'-'}</p>
	<DefaultDateInput
		id={propertyName}
		propertyName="value"
		value={parseUntilDate(filterOption.value)}
		callFunction={handleTillChange}
	/>
</div>
